<div>
    <co-image *ngIf="valueType == 'Boolean'" [imageSet]="imageSet" [key]="imageKey" isVault="false" width="16px" height="16px"> </co-image>
    <span *ngIf="valueType != 'Boolean'">{{titleAndValue.key}}</span>
</div>